export default __webpack_public_path__ + "static/media/waiting.8ea75568.svg";